<ng-container
  *ngIf="
    (objectTypesLoading$ | async) && (modelsLoading$ | async);
    else loadingFinishedSection
  "
>
  <div
    class="spinner-border text-primary m-3"
    style="width: 10rem; height: 10rem"
    role="status"
  ></div>
</ng-container>

<ng-template #loadingFinishedSection>
  <router-outlet></router-outlet>
</ng-template>
